import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const ShareBarLikeDrawerWrapper = styled.div`
  position: fixed;

  display: flex;
  flex-direction: column;

  & > :not(:last-child) {
    margin-bottom: 32px;
  }

  width: 100%;
  min-height: 100svh;

  background: #ffffff;

  padding: 48px;

  ${BREAKPOINTS.mobile} {
    padding: 24px 12px;
  }
`;

export const ShareBarLikeDrawerTitle = styled.h2`
  font-weight: 400;
  font-size: 24px;
  line-height: normal;

  color: var(--color-text);
`;

export const ShareBarLikeDrawerListContainer = styled.div`
  display: flex;
  flex-direction: column;

  & > :not(:last-child) {
    margin-bottom: 16px;
  }
`;
